import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { otpData } from './otp';
import { otpDataService } from './otp-data.service';
import { Router, ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalService } from '../model/global.service';


@Component({
  selector: 'app-otpverify',
  templateUrl: './otp.component.html'
})
export class EnterOTP implements OnInit, OnDestroy {

  public _form: FormGroup;
  public _formErrors: any;
  public _otpData: otpData;
  public _errorMessage: string;
  public _mobileNumber: any;
  public _mobileNumberData: any;
  public _customerID: any;
  public _errorStatus: any;

  constructor(private spinnerService: Ng4LoadingSpinnerService, private _formBuilder: FormBuilder, private _otpDataService: otpDataService, private _router: Router,
    private _activatedRoute: ActivatedRoute, private _globalService: GlobalService) {
    this._form = _formBuilder.group({
      otp: ['', Validators.compose([Validators.required])]
    })
  }

  // public onSubmit() {
  //   this._router.navigate(['/claimReward']);
  // }

  public ngOnInit() {
    if (this._globalService.mobileNumber) {
      debugger
      this._resetFormErrors();
      this._resetOtp();
      console.log("Global Number::", this._globalService.mobileNumber)
      this._activatedRoute.params.subscribe(params => {
        this._mobileNumber = this._globalService.mobileNumber;
        this._customerID = this._globalService.customerID;
      });
    } else {
      this._router.navigate(['/']);
    }
  }
  private _resetFormErrors(): void {
    this._formErrors = {
      otp: {
        valid: true, message: ''
      }
    }
  }
  private _resetOtp() {
    this._otpData = new otpData();
    this._otpData.otp = '';
  }

  private _setFormErrors(errorFields: any): void {
    for (let key in errorFields) {
      let errorField = errorFields[key];
      // skip loop if the property is from prototype
      if (!this._formErrors.hasOwnProperty(key)) continue;

      // let message = errorFields[error.field];
      this._formErrors[key].valid = false;
      this._formErrors[key].message = errorField;
    }
  }

  public onSubmit() {
    this.spinnerService.show();

    console.log("Clicked");
    this._otpData.otp = this._form.controls['otp'].value;
    this._otpData.mobile = this._mobileNumber.toString();
    this._otpData.campaign_id = 1;

     this._otpDataService.submitdetails(this._otpData)
      .subscribe(
        result => {
          if (result) {
            this.spinnerService.hide();
            console.log("Data Sent::", result);

            this._globalService.data.label = result.label;
            this._globalService.data.dataSet = result.data;
            this._globalService.data.customerData = result.customerdata;
            this._globalService.mobileNumber = '';
            this._router.navigate(['/claimReward']);
          }
        },
        error => {
          this.spinnerService.hide();
          this._errorStatus = error.status;
          //Validation errors
          if (error.status == 422) {
            this._errorMessage = error.message;
          }
          // Unauthorized Access
          else if (error.status == 401 || error.status == 403) {
            this._errorMessage = error.message;
          }
          // All other errors
          else {
            this._errorMessage = error.message;
          }

        }
      );
  }
  public ngOnDestroy() {
    this._otpData = new otpData();
  }

}



// WEBPACK FOOTER //
// ./src/app/otpVerify/otp.component.ts